module.exports = __webpack_public_path__ + "img/direct-debit-logo.f997cfa8.png";